import { customAxios } from '../../axios/CustomAxios';
import {myIpAddress} from "../../config";

/**
 * 버그 업데이트
 * @param body
 * @returns {Promise<axios.AxiosResponse<any>>}
 * @constructor
 */
const bugUpdate =(body)=>{
    return customAxios.post(myIpAddress+'/bug/bugUpdate', body );
}
export default bugUpdate;